import { RoleContext, RoleDispatchContext } from "context/RoleContext";
import { ROLE } from "helper/utility";
import { useQuery } from "@apollo/client";
import { DOWNLOAD_JUDGES_REPORT } from "redux/features/hostSlice/judgeSlice/judgeGql";
import { globalVariables } from "helper/globalVariables";
import { DownloadWhiteAlt } from "helper/icons";
import { TabBar } from "shared/Components/tabBar";
import { Button } from "shared/Components/button";
import { handleDownload } from "helper/utils";
import { ApprovedJudges } from "./components/ApprovedJudges";
import { PendingJudges } from "./components/PendingJudges";

import { useContext, useState } from "react";
import PageInfo from "shared/Components/pageInfo";

export const APPROVE_JUDGE = "Approved Judges";
export const APPROVE_OR_REJECT_JUDGE = "Approve/Reject Judges";

export const VIEW_JUDGE_TABS = [APPROVE_JUDGE, APPROVE_OR_REJECT_JUDGE];

export const ViewJudges = ({ isAdmin }) => {
  const [selectTab, setSelectTab] = useState(VIEW_JUDGE_TABS[0]);
  
  const role = useContext(RoleContext);
  
  return (
    <div className="flex flex-col App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
        {role === ROLE.SuperAdmin && (
          <TabBar
            tabs={VIEW_JUDGE_TABS}
            onChangeTab={(index) => {
              setSelectTab(VIEW_JUDGE_TABS[index]);
            }}
          />
        )}
        {selectTab === APPROVE_JUDGE && 
          <ApprovedJudges
            isAdmin={isAdmin}
          />
        }
        {selectTab === APPROVE_OR_REJECT_JUDGE && <PendingJudges />}
      </div>
  );
};
